<section class="wrapper" #wrapperElement>
    <ng-container [ngTemplateOutlet]="searchBar" *ngIf="!Mobile"></ng-container>

    <ngx-simplebar class="clickable-list-container scrollbar">
        <!-- Platzhalter für Buttons -->
        <th *ngIf="(Mobile$ | async)" style="height: 3.5rem;"></th>
        <table mat-table [dataSource]="DataSource$ | async" matSort>
            <ng-container *ngFor="let column of Columns.filter(FilterCustomColumns)" [matColumnDef]="column.name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ column.header }}</th>
                <td mat-cell *matCellDef="let rowData">{{ rowData[column.name] }}</td>
            </ng-container>

            <ng-container matColumnDef="Partner">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Partner</th>
                <td mat-cell *matCellDef="let rowData">
                    <div class="partner">
                        <div class="partner-img">
                            <fa-icon [icon]="rowData.Partner.Deleted ? 'user-slash' : 'user'" size="2x"></fa-icon>
                        </div>
                        <p>
                            <span>
                                {{rowData.Partner.Name}}
                            </span>
                        </p>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="chevron">
                <th mat-header-cell *matHeaderCellDef style="width: 30px;"></th>
                <td mat-cell *matCellDef="let rowData">
                    <div class="table-cell-wrapper">
                        <fa-icon icon="chevron-right"></fa-icon>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="DisplayedColumns$ | async"></tr>
            <tr
                mat-row
                *matRowDef="let rowData; columns: DisplayedColumns$ | async"
                [routerLink]="rowData.RouterLink"
                routerLinkActive="active"
            >
            </tr>

        </table>
        <table *ngIf="!((DataSource$ | async)?.data.length > 0)">
            <tr>
                <td class="empty-table-text">
                    Keine Partner vorhanden
                </td>
            </tr>
        </table>
    </ngx-simplebar>
</section>

<ng-template #searchBar>
    <header class="header">
        <fa-icon class="icon" icon="user" *ngIf="!(Mobile$ | async)" ></fa-icon>

        <div class="dark-theme title" *ngIf="ShowSearchBar$ | async; else searchBarInactive">
            <mat-form-field floatLabel="never" color="accent" [ngStyle]="{'width': (IsSmallWidth$ | async) ? '100%' : '50%' }">
                <mat-label>Suche nach Partnern und Benutzern</mat-label>
                <input type="text" [formControl]="SearchForm" matInput #input/>
                <button class="clear-search" (click)="SearchForm.setValue('')" mat-icon-button *ngIf="SearchForm.value">
                    <fa-icon icon="times"></fa-icon>
                </button>
            </mat-form-field>
        </div>
        <ng-template #searchBarInactive>
            <h3 *ngIf="!(Mobile$ | async)" >Partnerliste</h3>
        </ng-template>
        <!-- Suchen Button -->
        <button
            app-round-button
            Inverted
            matTooltipPosition="left"
            [matTooltip]="(ShowSearchBar$ | async) ? 'Ausblenden' : 'Suche'"
            (click)="ShowSearchBar$.next(!this.ShowSearchBar$.value)"
        >
            <fa-icon [icon]="(ShowSearchBar$ | async) ? 'times' : 'search'"></fa-icon>
        </button>
        <!-- Partner hinzufügen Button -->
        <a
            app-round-button
            Inverted
            matTooltip="Partner hinzufügen"
            matTooltipPosition="left"
            routerLink="/partner/neuerPartner"
            *ngIf="(PS.Has(PS.Permission.CreatePartner) | async) && !(ShowSearchBar$ | async)"
        >
            <app-double-icon Icon="user" Icon2="plus"></app-double-icon>
        </a>
    </header>
</ng-template>

<ng-template #loading>
    <p class="error-message">Lade Daten...</p>
</ng-template>

<ng-template #noListItems>
    <p class="error-message">Keine Einträge vorhanden.</p>
</ng-template>
